/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';

export const FETCH_POOLED_ACCOUNT_DETAILS_GQL = gql`
query FetchPooledAccountDetails($fetchProductPartnumberRequest: FetchProductPooledAccountRequest!) {
  fetchPooledAccountDetails(fetchProductPartnumberRequest: $fetchProductPartnumberRequest) {
    accountId
    dasAccount
    totalAccounts
    goldList {
      catEntryId
      item {
        fullImage
        name
        partnumber
      }
    ssProductItem{
      nameEN
      nameFR
      fullImage
      descriptionEN
      descriptionFR
      fullImage
    }
      productId
      availableQuantity
      totalQuantity
      tdWeightInOZ
      productType
    }
    platinumList {
      catEntryId
      item {
        fullImage
        description
        name
        partnumber
      }
       ssProductItem{
      nameEN
      nameFR
      fullImage
      descriptionEN
      descriptionFR
    }
      productId
      productType
      availableQuantity
      totalQuantity
      tdWeightInOZ
    }
    pooledAccountNumber
    silverList {
      catEntryId
      item {
        description
        fullImage
        name
        partnumber
      }
       ssProductItem{
      nameEN
      nameFR
      descriptionEN
      descriptionFR
      fullImage
    }
      productId
      productType
      availableQuantity
      totalQuantity
      tdWeightInOZ
    }
    accountStatus
  }
}
`;

export const useFetchPooledAccountDetails = ({PooledAccountId, onCompleted}: any) => {
  const variables = {
    fetchProductPartnumberRequest: {
      pooledAccountId: PooledAccountId
    }
  
};
    const { data, loading, error } = useQuery(FETCH_POOLED_ACCOUNT_DETAILS_GQL, {
        variables,
        fetchPolicy: "network-only",
        onCompleted,
         context:{
            clientName:"/secure-storage/manage"
        }
      });
      return { data, loading, error };
}
